<template>
    <el-row style="height: 100%">
        <el-row class="header" style="text-align: center">

            <h1 class="text-title"> 云上数据中心 </h1>

        </el-row>
        <el-row style="height: 40%">

            <el-row>

                <el-col :span="6" style="margin-left: 38%">
                    <el-form :model="loginForm" status-icon :rules="rule" ref="rule_form" class="demo-ruleForm">
                        <el-form-item label="用户名 :" prop="eMail">
                            <el-input v-model="loginForm.userId"></el-input>
                        </el-form-item>
                        <el-form-item label="密码 :" prop="password">
                            <el-input type="password" v-model="loginForm.password" autocomplete="off" show-password></el-input>
                        </el-form-item>
                        <el-form-item style="text-align: center">
                            <el-button @click="Login">登录</el-button>
                            <!-- <el-button @click="Register">Register</el-button> -->
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-row>
    </el-row>
</template>

<script>
    export default {
        name: "Login",
        data() {
            let validatenameInput= (rule, value, callback) => {
                if(value === '' || !value) {
                    callback(new Error('请输入用户名！'));
                }else {
                    callback();
                }
            };
            let validatepasswordInput= (rule, value, callback) => {
                if(value === '' || !value) {
                    callback(new Error('请输入密码！'));
                }else if (value.length < 6) {
                    callback(new Error('密码长度超过6位'))
                }else {
                    callback();
                }
            };
            return {
                loginForm: {
                    userId: '',
                    password: ''
                },
                rule: {
                    userId: [
                        {
                            validator: validatenameInput,
                            trigger: 'blur'
                        }
                    ],
                    password: [
                        {
                            validator: validatepasswordInput,
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        methods: {
            Login() {
                let _this = this;
                this.$api.post('/datacenter/login', this.loginForm, (res) => {
                    if(res.data.code == 200) {
                        _this.$cookie.set('token',res.data.data.token);
                        _this.$cookie.set('nickname',res.data.data.nickName);
                        _this.$cookie.set('org', res.data.data.org);
                        _this.$cookie.set('email', res.data.data.email);
                        _this.$cookie.set('userId', _this.loginForm.userId);
                        this.$router.push({path: '/index'})
                    }else {
                        _this.$message.error('用户名或密码错误');
                    }
                })
            },
            Register() {
                // this.$router.push({path: '/register'})
            },
            enterLogin(){
                  document.onkeydown = (e) => {
                    e = window.event || e;
                    
                    if (e.code == 'Enter' || e.code == 'enter') {
                let _this = this;
                this.$api.post('/datacenter/login', this.loginForm, (res) => {
                    if(res.data.code == 200) {
                        _this.$cookie.set('token',res.data.data.token);
                        _this.$cookie.set('nickname',res.data.data.nickName);
                        _this.$cookie.set('org', res.data.data.org);
                        _this.$cookie.set('email', res.data.data.email);
                        _this.$cookie.set('userId', _this.loginForm.userId);
                        this.$router.push({path: '/index'})
                    }else {
                        _this.$message.error('用户名或密码错误');
                    }
                })
                    }
                };
            }
        },
         created() {
            this.enterLogin();
        },
        mounted() {
            this.$store.commit('updateIsLogin', true);
            // this.$api.post('/datacenter/validateLogin', {}, (res) => {
            //     if (res.data.code == 200) {
            //         this.$router.push({path: '/index'})
            //     }
            // })

        }
    }
</script>

<style scoped>
    .text-title {
        color: #1470d2
    }

</style>